import type {CreateJobFormValues} from './types'

const GENERIC_JOB_NAMES = new Set(['service visit', 'deployment', 'pickup', 'job'])

export const JOB_NAME_HINT = "Describe the work, e.g. 'Deliver 30 mats'"

export function isRealJobName(name: string | null | undefined): boolean {
    const trimmed = (name ?? '').trim()
    return trimmed.length > 0 && !GENERIC_JOB_NAMES.has(trimmed.toLowerCase())
}

export function validateResources(values: CreateJobFormValues) {
    const errors: Record<string, string> = {}

    const workerTypeIds = new Set<string>()
    values.workerRequirements.forEach((requirement, index) => {
        if (!requirement.workerTypeId) {
            errors[`workerRequirements.${index}.workerTypeId`] = 'Worker type is required'
        } else if (workerTypeIds.has(requirement.workerTypeId)) {
            errors[`workerRequirements.${index}.workerTypeId`] =
                'Each worker type can only appear once'
        } else {
            workerTypeIds.add(requirement.workerTypeId)
        }
        if (requirement.quantity <= 0) {
            errors[`workerRequirements.${index}.quantity`] = 'Quantity must be greater than 0'
        }
        if (requirement.estimatedHours != null && requirement.estimatedHours <= 0) {
            errors[`workerRequirements.${index}.estimatedHours`] =
                'Estimated hours must be greater than 0'
        }
        const hasBillingRate =
            requirement.billingRate != null && requirement.billingRate.trim() !== ''
        const hasBillingType = requirement.billingType != null
        if (hasBillingRate !== hasBillingType) {
            errors[`workerRequirements.${index}.billingRate`] =
                'Billing rate and type must both be provided or both empty'
            errors[`workerRequirements.${index}.billingType`] =
                'Billing rate and type must both be provided or both empty'
        }
        if (hasBillingRate && isNaN(Number(requirement.billingRate))) {
            errors[`workerRequirements.${index}.billingRate`] =
                'Billing rate must be a valid number'
        }
        if (hasBillingRate && Number(requirement.billingRate) < 0) {
            errors[`workerRequirements.${index}.billingRate`] = 'Billing rate must not be negative'
        }
    })

    const assetTypeIds = new Set<string>()
    values.assetRequirements.forEach((requirement, index) => {
        if (!requirement.rentalAssetTypeId) {
            errors[`assetRequirements.${index}.rentalAssetTypeId`] = 'Rental asset type is required'
        } else if (assetTypeIds.has(requirement.rentalAssetTypeId)) {
            errors[`assetRequirements.${index}.rentalAssetTypeId`] =
                'Each rental asset type can only appear once'
        } else {
            assetTypeIds.add(requirement.rentalAssetTypeId)
        }
        if (requirement.quantity <= 0) {
            errors[`assetRequirements.${index}.quantity`] = 'Quantity must be greater than 0'
        }
        const hasBillingRate =
            requirement.billingRate != null && requirement.billingRate.trim() !== ''
        const hasBillingType = requirement.billingType != null
        if (hasBillingRate !== hasBillingType) {
            errors[`assetRequirements.${index}.billingRate`] =
                'Billing rate and type must both be provided or both empty'
            errors[`assetRequirements.${index}.billingType`] =
                'Billing rate and type must both be provided or both empty'
        }
        if (hasBillingRate && isNaN(Number(requirement.billingRate))) {
            errors[`assetRequirements.${index}.billingRate`] = 'Billing rate must be a valid number'
        }
        if (hasBillingRate && Number(requirement.billingRate) < 0) {
            errors[`assetRequirements.${index}.billingRate`] = 'Billing rate must not be negative'
        }
    })

    return errors
}
